<mat-accordion>
  <mat-expansion-panel
    [expanded]="true"
    (click)="click()"
    class="solar-expansion-container"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <ng-container *ngIf="iconPerformance">
          <i
            class="fa fa-sort-desc arrow-expansion-panel-customize desc"
            aria-hidden="true"
          ></i>
        </ng-container>
        <ng-container *ngIf="!iconPerformance">
          <i
            class="fa fa-sort-asc arrow-expansion-panel-customize asc"
            aria-hidden="true"
          ></i>
        </ng-container>
        <span class="title-header">Performance characteristics</span>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div
      fxFlex="100%"
      fxFlex.xs="100%"
      fxLayout="row wrap"
      fxLayout.xs="column"
      fxLayoutAlign="center center"
      class="performance-container"
    >
      <div
        fxLayout="row wrap"
        fxLayout.xs="row"
        fxLayout.sm="row"
        fxFlex="100%"
        fxFlex.xs="100%"
        fxLayoutAlign="left center"
      >
        <div
          fxFlex="30%;"
          fxFlex.xs="25%"
          fxFlex.sm="30%"
          [chart]="netACPowerHC"
        ></div>
        <div
          fxFlex="70%"
          fxFlex.xs="75%"
          fxLayout="column wrap"
          fxFlex.sm="70%"
          fxLayoutAlign="left left"
        >
          <span class="performance-title">Today's Cumulative Energy</span>
          <span class="performance-value"
            >{{ todayEnergy | number: '1.2-2' }} kWh</span
          >
        </div>
      </div>
      <div
        fxLayout="row wrap"
        fxLayout.xs="row"
        fxLayout.sm="row"
        fxFlex="100%"
        fxFlex.xs="100%"
        fxLayoutAlign="left center"
      >
        <div
          fxFlex="30%;"
          fxFlex.xs="25%"
          fxFlex.sm="30%"
          [chart]="performanceRatioHC"
        ></div>
        <div
          fxFlex="70%"
          fxFlex.xs="75%"
          fxLayout="column wrap"
          fxFlex.sm="70%"
          fxLayoutAlign="left left"
        >
          <span class="performance-title">Todays Cumulative PR</span>
          <span class="performance-value"
            >{{ todayPR | number: '1.2-2' }} %</span
          >
        </div>
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
